angular.module("UI8.controllers").controller("CartController", [
  "$scope",
  "$rootScope",
  "AccountService",
  "CartService",
  "FlashService",
  "PaymentService",
  "UserService",
  "PromoService",
  function (
    $scope,
    $rootScope,
    AccountService,
    CartService,
    FlashService,
    PaymentService,
    UserService,
    PromoService
  ) {
    var $body;
    var $groupCart;
    var $groupDropdown;
    var $groupClose;
    var $groupNext;
    var $groupLayout;
    var $groupBack;

    var upsellInfo = null;
    var upsellInfoLoading = false;
    var upsellShownThisOpen = false;

    function updateScope(cart) {
      if (cart && cart.items) cart.items.reverse();
      $scope.cart = cart ? cart : { items: [] };
      $scope.itemCount = cart && cart.items_sum ? cart.items_sum : 0;

      // keep the inline payment element in step with the cart contents
      setTimeout(syncInlineElements, 50);

      var firstItem = $scope.cart.items && $scope.cart.items[0];
      $scope.isExclusive =
        firstItem &&
        firstItem.product &&
        firstItem.product.slug === "all-access-pass-exclusive";

      // UI8 Hire (UI8-16) has no PayPal billing plan, so PayPal is hidden
      // for a hire cart rather than failing at the last step.
      var hireIds = (window.UI8 && UI8.hire) || {};
      $scope.hasHireItem = ($scope.cart.items || []).some(function (item) {
        var id = item.product && item.product._id;
        return (
          !!id &&
          (String(id) === hireIds.monthly || String(id) === hireIds.yearly)
        );
      });

      computeUpsell();
    }

    function computeUpsell() {
      var items = ($scope.cart && $scope.cart.items) || [];
      $scope.upsell.eligible = false;

      if (!items.length || $scope.isExclusive) return;
      if ($rootScope.user && $rootScope.user.pass_holder) return;

      var hasSubscription = items.some(function (item) {
        return item.product && item.product.is_subscription;
      });
      if (hasSubscription) return;

      if (!upsellInfo) return loadUpsellInfo();
      if (!upsellInfo.product || !upsellInfo.threshold) return;

      var delta = upsellInfo.price - $scope.cart.total;
      if (delta > upsellInfo.threshold) return;

      $scope.upsell.delta = delta;
      $scope.upsell.image = upsellInfo.image;
      $scope.upsell.count = upsellInfo.count;
      $scope.upsell.eligible = true;
      maybeTrackUpsellShown();
    }

    function loadUpsellInfo() {
      if (upsellInfoLoading) return;
      upsellInfoLoading = true;

      CartService.getUpsellInfo(function (err, info) {
        upsellInfoLoading = false;
        if (err || !info) return;
        upsellInfo = info;
        computeUpsell();
      });
    }

    function maybeTrackUpsellShown() {
      if (upsellShownThisOpen) return;
      if (!$scope.upsell.eligible) return;
      if (!$groupCart || !$groupCart.hasClass("active")) return;
      upsellShownThisOpen = true;
      trackUpsell("cart_upsell_shown");
    }

    function trackUpsell(event) {
      try {
        window.dataLayer.push({
          event: event,
          value: ($scope.upsell.delta || 0) / 100,
        });
      } catch (e) {
        console.log("Unable to track upsell: " + e.message);
      }
    }

    function setUserParams(user) {
      if (!user) return;
      $scope.payment_details.email = $scope.currentUserEmail =
        user.email || undefined;
      $scope.payment_details.name = user.first_name
        ? user.first_name + " " + user.last_name
        : undefined;

      AccountService.listCards(function (err, cardData) {
        if (err) console.log("Error listing payment cards");

        var defaultCard = (cardData && cardData.defaultCard) || undefined;
        $scope.default_card = defaultCard;
        $scope.savedBrandIcon =
          (defaultCard &&
            CARD_BRAND_ICONS[(defaultCard.brand || "").toLowerCase()]) ||
          null;
      });
    }

    // Signed-out checkout starts at the email field — cursor ready.
    // The cart renders async, so retry until the input exists and takes
    // focus (or give up quietly).
    function focusEmailSoon(delay) {
      if ($rootScope.user) return;
      var attempts = 0;
      function tryFocus() {
        attempts++;
        var $email = $groupCart ? $groupCart.find(".tab-email") : null;
        if ($email && $email.length && !$email.prop("disabled")) {
          $email[0].focus();
          if (document.activeElement === $email[0]) return;
        }
        if (attempts < 20) setTimeout(tryFocus, 300);
      }
      setTimeout(tryFocus, delay || 300);
    }

    function bodyClickHandler() {
      if ($groupCart.hasClass("active")) {
        $body.removeClass("cart");
        $groupCart.removeClass("active");
        window.scrollLock.enablePageScroll();
      }
    }

    $scope.payment_details = {};
    $scope.upsell = { eligible: false, delta: 0, swapping: false };
    $scope.userExists = false;
    $scope.enteringPromotion = false;
    $scope.cardPlaceholder = "Card Number";
    $scope.cvcPlaceholder = "CVC";
    $scope.newPromoCode = "";
    $scope.useNewCard = false;

    var CARD_BRAND_ICONS = {
      visa: "/img/payments/visa.svg",
      mastercard: "/img/payments/mastercard.svg",
      amex: "/img/payments/amex.svg",
      "american express": "/img/payments/amex.svg",
      discover: "/img/payments/discover.svg",
    };

    // Saved-card checkout: default on when a card is on file; the manual
    // fields mount lazily if the user switches
    $scope.useAnotherCard = function () {
      $scope.useNewCard = true;
      setTimeout(syncInlineElements, 50);
    };

    // Admin-only: swap between the inline/hosted flow and the legacy
    // card form (manual renewals for legacy subscribers via impersonation)
    $scope.toggleLegacyProcessor = function () {
      $scope.processor =
        $scope.processor === "stripe" ? "stripe-checkout" : "stripe";
    };

    $scope.init = function () {
      $scope.processor = "stripe-checkout";
      $scope.inlineVariant = false;

      PaymentService.checkoutVariant(function (err, variant) {
        $scope.$applyAsync(function () {
          $scope.inlineVariant = variant === "inline";
          if ($scope.inlineVariant) syncInlineElements();
        });
      });
      $scope.saveCard = true;
      $scope.passwordHidden = true;

      $body = $("body");
      $groupCart = $(".header__cell--cart");

      if ($rootScope.user) setUserParams($rootScope.user);

      CartService.getCart(function (err, cart) {
        updateScope(cart);

        setTimeout(function () {
          $("body").addClass("loaded");

          if ($scope.itemCount) {
            $groupNext = $groupCart.find(".payup__sidebar .payup__btn");
            $groupLayout = $groupCart.find(".payup__layout");
            $groupBack = $groupCart.find(".payup__back");

            $groupNext.on("click", function () {
              $groupLayout.addClass("step-checkout");
              if ($scope.inlineVariant) syncInlineElements();
              focusEmailSoon(250);
            });

            $groupBack.on("click", function () {
              $groupLayout.removeClass("step-checkout");
            });
          }
        }, 10);
      });

      if (
        window &&
        window.location.search &&
        /showCart/.test(window.location.search)
      ) {
        $groupCart.addClass("active");
        $body.addClass("cart");
        focusEmailSoon(600);
      }

      $groupCart.find(".header__head").on("click", function (e) {
        e.stopPropagation();

        $body
          .find(".header__cell:not(.header__cell--cart)")
          .removeClass("active-touch");

        if ($scope.itemCount) $body.toggleClass("cart");

        if ($groupCart.hasClass("active")) {
          $groupCart.removeClass("active");
          window.scrollLock.enablePageScroll();
        } else {
          $groupCart.addClass("active");
          window.scrollLock.disablePageScroll();
          focusEmailSoon(350);
        }
      });

      $groupCart.on("click", function (e) {
        e.stopPropagation();
      });

      $groupClose = $groupCart.find(".header__logo, .header__close");
      $groupClose.on("click", function () {
        $body.removeClass("cart");
        $groupCart.removeClass("active");
        window.scrollLock.enablePageScroll();
      });

      $groupDropdown = $groupCart.find(".header__dropdown");
      $groupDropdown.on("scroll", function () {
        if ($groupDropdown.scrollTop() > 0) {
          $groupDropdown.addClass("active");
        } else {
          $groupDropdown.removeClass("active");
        }
      });

      $groupCart.on("mouseleave", function () {
        if (!$scope.itemCount) {
          $groupCart.removeClass("active");
          $body.removeClass("cart");
          window.scrollLock.enablePageScroll();
        }
      });

      $body.on("click", bodyClickHandler);
    };

    $scope.$on("$destroy", function () {
      $groupCart.off();
      $body.off("click", bodyClickHandler);
    });

    $scope.togglePasswordVisibility = function ($event) {
      $event.stopPropagation();
      var input = $($event.currentTarget).siblings("input");
      if (input.attr("type") === "password") {
        input.attr("type", "text");
        $scope.passwordHidden = false;
      } else {
        input.attr("type", "password");
        $scope.passwordHidden = true;
      }
    };

    $scope.checkUserEmail = function () {
      if ($scope.currentUserEmail) return;

      // rebuild the payment element with the typed email so Link can
      // recognize the session without its own email popover
      if ($scope.inlineVariant) setTimeout(syncInlineElements, 50);

      UserService.userExists($scope.payment_details.email, function (
        err,
        exists
      ) {
        $scope.userExists = exists;
      });
    };

    $scope.acceptUpsell = function () {
      if ($scope.upsell.swapping || !upsellInfo || !upsellInfo.product) return;
      $scope.upsell.swapping = true;
      trackUpsell("cart_upsell_accepted");

      // Adding a subscription product replaces the whole cart server-side
      // (see api/controllers/cart.js exports.add), so this IS the swap.
      var addPass = function () {
        CartService.addPassToCart(upsellInfo.product, function (error) {
          $scope.upsell.swapping = false;
          if (error)
            FlashService.set("error", "Unable to add All-Access to your cart");
        });
      };

      // A sale-priced pass needs its promo on the cart first, the same path
      // the pass modal takes, or the cart would bill the full price.
      if (!upsellInfo.promo) return addPass();
      PromoService.applyPromo(upsellInfo.promo).then(function (promo) {
        if (promo) {
          window.UI8.promo = promo;
          document.body.dispatchEvent(new Event("promo-updated"));
        }
        addPass();
      });
    };

    $scope.removeItem = function (itemId) {
      if ($scope.cart.items.length <= 1) {
        $scope.itemCount = 0;
        $scope.cart.items = [];
        $body.removeClass("cart");
        window.scrollLock.enablePageScroll();
      } else {
        $scope.cart.items = $scope.cart.items.filter(function (item) {
          return String(item._id) !== itemId;
        });
      }

      CartService.removeFromCart(itemId, function (error, cart) {
        updateScope(cart);
      });
    };

    $scope.updateProcessor = function (processor) {
      $scope.processor = processor;
    };

    $scope.creditCardType = function () {
      return (
        ($scope.PaymentForm.number &&
          $scope.PaymentForm.number.$ccEagerType &&
          $scope.PaymentForm.number.$ccEagerType
            .toLowerCase()
            .replace(" ", "-")) ||
        ($scope.default_card &&
          $scope.default_card.brand.toLowerCase().replace(" ", "-"))
      );
    };

    $scope.toggleCardSave = function () {
      if ($scope.default_card) return;
      $scope.saveCard = !$scope.saveCard;
    };

    $scope.toggleUseNewCard = function () {
      $scope.useNewCard = !$scope.useNewCard;
    };

    function processPayment() {
      $scope.processing = true;

      // Get recaptcha token. Use window.grecaptcha (not the bare identifier):
      // if the script was blocked by a content blocker the bare reference
      // throws a ReferenceError and leaves the button stuck on "processing".
      var rc = window.grecaptcha;
      var rcKey = UI8.recaptchaSiteKey;
      if (!rc || !rcKey) {
        if (window.bugsnagClient)
          window.bugsnagClient.notify("Checkout error: no recaptcha found");

        FlashService.set(
          "error",
          "Payment couldn't start — reCAPTCHA appears to be blocked. Please disable your content blocker for ui8.net and try again."
        );
        $scope.processing = false;
        return;
      }

      var rcPromise;
      try {
        rcPromise = rc.execute(rcKey, { action: "checkout" });
      } catch (e) {
        $scope.processing = false;
        return FlashService.set(
          "error",
          "Payment couldn't start — reCAPTCHA appears to be blocked. Please disable your content blocker for ui8.net and try again."
        );
      }

      rcPromise
        .then(function (token) {
          sendCheckoutToServer(token);
        })
        .catch(function (error) {
          console.log("Error executing recaptcha for checkout");
          if (window.bugsnagClient) window.bugsnagClient.notify(error);
          FlashService.set(
            "error",
            "Unable to start payment. Please refresh the page and try again."
          );
          $scope.processing = false;
          $scope.$applyAsync();
        });
    }

    function removePromo(location) {
      PromoService.disablePromo().then(function () {
        UI8.promo = null;
        var event = new Event("promo-updated");
        document.body.dispatchEvent(event);
        window.location = location;
      });
    }

    // ---- inline checkout (arm B: split elements + wallets + Link route) --
    // Card fields are Stripe split elements mounted inside OUR .field
    // containers (focus/invalid arrive as StripeElement--* classes on the
    // container, so every visual state is our CSS). Wallets ride the
    // classic paymentRequest button. The Link row routes to the hosted
    // Checkout page where Link is native.
    var inlineStripe = null;
    var inlineCard = null;
    var inlineExpiry = null;
    var inlineCvc = null;
    var inlineElementsBag = null;
    var inlinePR = null;
    var inlineMounted = false;

    var ELEMENT_STYLE = {
      base: {
        color: "#F8F8F8",
        fontSize: "15px",
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif',
        "::placeholder": { color: "#5C5C5C" },
        // Safari paints autofilled fields yellow — keep our dark theme
        ":-webkit-autofill": {
          color: "#F8F8F8",
          backgroundColor: "#262626",
        },
      },
      invalid: { color: "#FF5A43" },
    };

    // CVC renders masked discs instead of digits. Stripe's style
    // whitelist has no text-security, so the mask is a font whose every
    // glyph is a disc (text-security@3.2.1, 784b woff2 inlined below);
    // fontSize sets disc diameter, letterSpacing the gap between discs.
    // No placeholder — the field label already says CVC, and the disc
    // font would mask the placeholder too.
    var DISC_FONT_B64 =
      "d09GMgABAAAAAAMQAAoAAAAACAAAAALIAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAABmAAggAKcHILBgABNgIkAwYEIAWJSAcvG0gHEZWcjBRfHNjNPraIGU7SkQoTFkXoFRjv8FUcbDmIj4fv117P3fcRQioFRseKQUaWwJVVVVWlqUSWQCqzAXDOVp+vqsnVapWIlhw7yBoEhhMnHFYCHMKOvkR03bf6e9V3k5C0pdB3/e9T0qkd4MMPltYAwwl4rBdKBw5Q6WQJiMe2JfXQzxqDHiJHyBCRoyWk9D0eokh2Ww9se/9MHLHYawD4n5f/Ls/b722ATVs377KRPE9jOdKY88cWRA5gIghJDQ1N8AfoA89ygvcYf4pg/Ec+TgiEgQwZEhIKKKCIIkoooYwyKqigiipqqKGOOhpooIkmWmihjTY66PxOyEABGSZiKqAAQnQ6B6/n1u98x4262u0Js8WuS9OPfJk+/cuR6bOAtTcIJOZcuOuj7bV/Kyl9h9f38fFYbrefcSYrI8lAQDMUDxExOyyGlfQ/vVsg0xGArgJ1t5MoVLEcA2Gq5ci0HECy2rnswoOiU55kl1xUjEQJdXtiFM3sEWm9lqWFmgZbjP05LRVBvbqdHux9wpyGnbGWEX6p5JEHp+lXirTnJ5QhZa5Rrsq9D67r+24QRrdzndcmBzUrQ9xXb6hp/3Kt1h1kLEFUI/CLVKdW/dqtdrVRNqpIyLr2KxU5WYVXmZuskh+VXqlluyjNMNPGBGcj6JOF0MC+M9Ucc48RhDxCB6QQzssN7C3m8bmbGCrG7VXU5FY+yGdUakVOvwKllMExtmsLwzMsVQFGpi5UbHxfXhb762Voh6fTcKeW03OxxicY73eTpa8bxhIzeWR+wnoJ6j/4kBejs2xf69j7pOSUzmzPCqNy4cojtlsLwpBhb++AtcBHQcpyGZgkYrGUBTwXn2/RF12BjlQTI1XSvANELqO18DPB+UIyNkJSZBsoX7wh7DlfsyVfTshpuSjLSv9H3fwD+a36nwAAkBFZ5aSOqp+7Bg==";
    var CVC_STYLE = {
      base: angular.extend({}, ELEMENT_STYLE.base, {
        fontFamily: "text-security-disc",
        fontSize: "12px",
        letterSpacing: "4px",
        // the disc font would mask the placeholder too — restore the
        // normal face and metrics for it
        "::placeholder": {
          color: "#5C5C5C",
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif',
          fontSize: "15px",
          letterSpacing: "0",
        },
      }),
      invalid: ELEMENT_STYLE.invalid,
    };

    function loadStripeV3(cb) {
      if (window.__stripeV3Loaded) return cb(null);
      var s = document.createElement("script");
      s.src = "https://js.stripe.com/v3/";
      s.onload = function () {
        window.__stripeV3Loaded = true;
        cb(null);
      };
      s.onerror = function () {
        cb(new Error("Unable to load Stripe.js v3"));
      };
      document.head.appendChild(s);
    }

    var mountRetryTimer = null;
    var pendingWalletBtn = null;

    // The drawer's checkout step reveals with a CSS transition — fixed
    // timers lose that race and Stripe iframes freeze at the width they
    // measured while hidden. Poll until actually visible and healthy.
    function ensureMountedSoon() {
      if (mountRetryTimer) return;
      var tries = 0;
      mountRetryTimer = setInterval(function () {
        tries++;
        var node = document.getElementById("cart-card-number");
        if (node && node.offsetWidth >= 20) {
          mountSplitFields();
          if (pendingWalletBtn) {
            var wallet = document.getElementById("cart-wallet-button");
            if (wallet && !wallet.querySelector("iframe")) {
              pendingWalletBtn.mount("#cart-wallet-button");
              $scope.$applyAsync(function () {
                $scope.walletAvailable = true;
              });
            }
          }
        }
        var frame = node && node.querySelector("iframe");
        var healthy = frame && frame.getBoundingClientRect().width > 10;
        if (healthy || tries > 25) {
          clearInterval(mountRetryTimer);
          mountRetryTimer = null;
        }
      }, 200);
    }

    function syncInlineElements() {
      if (!$scope.inlineVariant || !$scope.itemCount) return;

      loadStripeV3(function (err) {
        if (err) return console.log("Stripe.js v3 failed to load");
        if (!inlineStripe) inlineStripe = window.Stripe(window.UI8.stripePk);
        if (!inlineElementsBag)
          inlineElementsBag = inlineStripe.elements({
            fonts: [
              {
                family: "text-security-disc",
                src: "url(data:font/woff2;base64," + DISC_FONT_B64 + ")",
              },
            ],
          });
        setupPaymentRequest();
        ensureMountedSoon();
      });
    }

    function mountSplitFields() {
      var node = document.getElementById("cart-card-number");
      if (!node) return;
      // split elements measure their container ONCE at mount — mounting
      // while the checkout step is hidden freezes the iframe at ~1px.
      // Only mount when visible, and self-heal a frozen mount.
      if (node.offsetWidth < 20) return;

      if (inlineMounted) {
        var fr = node.querySelector("iframe");
        if (fr && fr.getBoundingClientRect().width > 10) return; // healthy
        try {
          inlineCard.destroy();
          inlineExpiry.destroy();
          inlineCvc.destroy();
        } catch (e) {}
        inlineMounted = false;
      }

      inlineCard = inlineElementsBag.create("cardNumber", {
        style: ELEMENT_STYLE,
        // brand icon is ours, on the right (see .payup__brand)
        showIcon: false,
        placeholder: "1234 1234 1234 1234",
        // no Link autofill chip in the card field — Link lives on its row
        disableLink: true,
      });

      inlineCard.on("change", function (ev) {
        $scope.$applyAsync(function () {
          $scope.cardBrandIcon = (ev && CARD_BRAND_ICONS[ev.brand]) || null;
        });
      });
      inlineExpiry = inlineElementsBag.create("cardExpiry", {
        style: ELEMENT_STYLE,
      });
      inlineCvc = inlineElementsBag.create("cardCvc", {
        style: CVC_STYLE,
        placeholder: "123",
      });

      inlineCard.mount("#cart-card-number");
      inlineExpiry.mount("#cart-card-expiry");
      inlineCvc.mount("#cart-card-cvc");
      inlineMounted = true;
    }

    // Apple Pay / Google Pay via the classic payment request button.
    // Apple Pay additionally requires the domain to be verified in the
    // Stripe dashboard before Safari will offer it.
    function setupPaymentRequest() {
      var amount = ($scope.cart && $scope.cart.total) || 0;
      if (amount < 1) return;

      if (inlinePR) {
        inlinePR.update({ total: { label: "UI8", amount: amount } });
        return;
      }

      inlinePR = inlineStripe.paymentRequest({
        country: "AE", // Stripe account country (Robot Global FZCO)
        currency: "usd",
        total: { label: "UI8", amount: amount },
        requestPayerEmail: true,
        requestPayerName: true,
        // real wallets only — Link belongs to its own row (hosted route)
        disableWallets: ["link", "browserCard"],
      });

      inlinePR.on("paymentmethod", onWalletPayment);

      inlinePR.canMakePayment().then(function (available) {
        if (!available) return;
        var btn = inlineElementsBag.create("paymentRequestButton", {
          paymentRequest: inlinePR,
          style: {
            paymentRequestButton: { theme: "dark", height: "44px" },
          },
        });

        // Signed-out wallet taps still need an email first — block the
        // sheet and light up the email field instead
        btn.on("click", function (ev) {
          if ($scope.currentUserEmail) return;
          var form = $scope.PaymentForm;
          if (form && form.email && !form.email.$invalid) return;
          ev.preventDefault();
          $scope.$applyAsync(function () {
            $scope.submitted = true;
          });
          focusEmailSoon(0);
        });
        pendingWalletBtn = btn;
        ensureMountedSoon();
      });
    }

    function onWalletPayment(ev) {
      var rc = window.grecaptcha;
      var rcKey = UI8.recaptchaSiteKey;
      if (!rc || !rcKey) {
        ev.complete("fail");
        return inlineFail("Payment couldn't start — please try again.");
      }

      var rcPromise;
      try {
        rcPromise = rc.execute(rcKey, { action: "checkout" });
      } catch (e) {
        ev.complete("fail");
        return inlineFail("Payment couldn't start — please try again.");
      }

      rcPromise.then(function (token) {
        var payload = angular.extend({}, $scope.payment_details, {
          rcToken: token,
          email: $scope.payment_details.email || ev.payerEmail,
          name: $scope.payment_details.name || ev.payerName,
          currentUrl: window.location.href,
        });

        PaymentService.stripeElements(payload, function (err, res) {
          if (err || res.error || !res.clientSecret) {
            ev.complete("fail");
            return inlineFail(err || (res && res.error));
          }

          inlineStripe
            .confirmCardPayment(
              res.clientSecret,
              { payment_method: ev.paymentMethod.id },
              { handleActions: false }
            )
            .then(function (result) {
              if (result.error) {
                ev.complete("fail");
                return inlineFail(result.error.message);
              }
              ev.complete("success");
              if (
                result.paymentIntent &&
                result.paymentIntent.status === "requires_action"
              ) {
                // 3DS after the wallet sheet closes
                return inlineStripe
                  .confirmCardPayment(res.clientSecret)
                  .then(function (r2) {
                    if (r2.error) return inlineFail(r2.error.message);
                    removePromo(res.returnUrl);
                  });
              }
              removePromo(res.returnUrl);
            });
        });
      });
    }

    function inlineFail(message) {
      FlashService.set(
        "error",
        message || "Payment failed. Please try again.",
        6000
      );
      $scope.$applyAsync(function () {
        $scope.processing = false;
      });
    }

    // Card path: rcToken is already on payment_details (the normal
    // submitPayment -> recaptcha -> dispatch chain got us here)
    function processInlinePayment() {
      var usingSaved = !!($scope.default_card && !$scope.useNewCard);
      if (!usingSaved && !inlineMounted)
        return inlineFail("Payment form is not ready yet, one moment.");

      PaymentService.stripeElements($scope.payment_details, function (
        err,
        res
      ) {
        if (err || res.error) return inlineFail(err || res.error);
        // Hire carts (UI8-16) are delegated server-side to hosted
        // Checkout — follow the redirect like the hosted arm does
        if (res.link) return removePromo(res.link);
        if (!res.inline || !res.clientSecret)
          return inlineFail("Unable to start payment");

        if (window.dataLayer)
          window.dataLayer.push({
            event: "checkout_view",
            checkout_variant: "inline",
          });

        inlineStripe
          .confirmCardPayment(
            res.clientSecret,
            usingSaved
              ? { payment_method: $scope.default_card.id }
              : {
                  payment_method: {
                    card: inlineCard,
                    billing_details: {
                      email: $scope.payment_details.email || undefined,
                      name: $scope.payment_details.name || undefined,
                    },
                  },
                }
          )
          .then(function (result) {
            if (result && result.error) return inlineFail(result.error.message);
            removePromo(res.returnUrl);
          })
          .catch(function () {
            inlineFail(null);
          });
      });
    }

    // "Secure, fast checkout with Link": hosted Checkout has Link native —
    // same validation + recaptcha chain, hosted dispatch
    $scope.linkCheckout = function () {
      $scope.viaLink = true;
      $scope.submitPayment();
    };

    // Quick-checkout PayPal button — a flag, not a state flip, so the
    // card form never disappears and validation failures leave no residue
    $scope.paypalQuick = function () {
      $scope.viaPaypal = true;
      $scope.submitPayment();
    };
    // ---- end inline checkout --------------------------------------------

    function sendCheckoutToServer(token) {
      $scope.payment_details.rcToken = token;
      // The idempotency key is a Stripe API idempotency header only — it
      // no longer identifies anything in analytics. Purchase conversions
      // fire server-verified after processor confirmation (see
      // settle-paid-order.js and the purchases-page event), never at
      // checkout submit.
      if (!UI8.idempotencyKey && window.uuidv4)
        UI8.idempotencyKey = window.uuidv4();
      $scope.payment_details.idempotencyKey = UI8.idempotencyKey;

      if ($scope.processor === "stripe") {
        if ($scope.default_card && !$scope.payment_details.card_number) {
          $scope.payment_details.stripeType = "existing";
          $scope.payment_details.stripeSource = $scope.default_card.id;
        } else {
          $scope.payment_details.stripeType = "new";
          $scope.payment_details.saveCard = $scope.saveCard.toString();
        }

        PaymentService.stripe($scope.payment_details, function (err, res) {
          if (err || res.error) {
            if ($scope.payment_details.stripeToken)
              delete $scope.payment_details.stripeToken;
            $scope.processing = false;
            console.log(err || res.error);
            if (window.bugsnagClient)
              window.bugsnagClient.notify(err || res.error);

            UI8.idempotencyKey = window.uuidv4();

            return FlashService.set("error", err || res.error);
          }
          // success — res.link carries the aap_purchased params that fire
          // the purchases-page toast + GA conversion event (hardcoding the
          // bare path here had silently dropped them since 2017)
          return removePromo(res.link || "/account/purchases");
        });
      } else if ($scope.processor === "paypal" || $scope.viaPaypal) {
        $scope.viaPaypal = false;
        PaymentService.paypal($scope.payment_details, function (err, res) {
          if (err || res.error)
            return FlashService.set("error", err || res.error);
          if (res.link) {
            // success
            return removePromo(res.link);
          }
          $scope.processing = false;
          FlashService.set("error", "Unable to submit payment");
        });
      } else if (
        $scope.processor === "stripe-checkout" &&
        $scope.inlineVariant &&
        !$scope.viaLink
      ) {
        // Checkout A/B arm B: custom split-element card flow
        return processInlinePayment();
      } else if ($scope.processor === "stripe-checkout") {
        $scope.viaLink = false;
        $scope.payment_details.currentUrl = window.location.href;

        PaymentService.stripeCheckout($scope.payment_details, function (
          err,
          res
        ) {
          if (err || res.error)
            return FlashService.set("error", err || res.error);
          if (res.link) {
            // success
            if (window.dataLayer)
              window.dataLayer.push({
                event: "checkout_view",
                checkout_variant: "redirect",
              });
            return removePromo(res.link);
          }
        });
      } else {
        $scope.processing = false;
        FlashService.set("error", "Unable to submit payment");
      }
    }

    $scope.submitPayment = function () {
      $scope.submitted = true;
      if ($scope.userExists || $scope.PaymentForm.$invalid) {
        $scope.viaLink = false;
        $scope.viaPaypal = false;
        return;
      }
      return processPayment();
    };

    $scope.closeCart = function (e) {
      $groupCart.removeClass("active");
      if ($scope.itemCount) $body.removeClass("cart");
      if (e) e.stopPropagation();
    };

    $scope.getPlaceholders = function () {
      if ($scope.cart && $scope.cart.items) {
        if ($scope.cart.items.length > 1) return [];
        return new Array(3 - $scope.cart.items.length);
      }
      return [];
    };

    $scope.advanceCursor = function (e) {
      if (e.target.value.length < 2) return;
      if (["TAB", "SHIFT"].includes(e.key.toUpperCase())) return;

      if (e.target.name === "exp_month") {
        $("input[name='exp_year']").focus();
      } else if (e.target.name === "exp_year") {
        $("input[name='cvc").focus();
      }
    };

    $scope.subscriptionAccess = function (sub_term, lifetime) {
      if (lifetime) {
        return "Lifetime access";
      } else if (sub_term) {
        return sub_term + " month access";
      } else {
        return "";
      }
    };

    // Watch for new items being added to the cart
    $rootScope.$watch("cart", function (cart) {
      if (cart) {
        updateScope(cart);
        $groupCart.addClass("active");
        if (cart.items && cart.items.length) {
          $body.addClass("cart");
        } else {
          $body.removeClass("cart");
        }
      }
    });

    $rootScope.$watch("user", function (user) {
      setUserParams(user);
    });

    // Modify keydown handler on document when cart 'active' state changes
    var targetNode = document.getElementsByClassName("header__cell--cart")[0];
    var searchKeydown;
    var active;

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.attributeName !== "class") return;
        var classes = [];

        if (Array.from) {
          classes = Array.from(targetNode.classList);
        } else {
          classes = [].slice.apply(targetNode.classList);
        }
        if (classes.indexOf("active") > -1 && !active) {
          active = true;
          $(targetNode).find('input[name="email"]').focus();
          // drawer just opened — (re)mount the Stripe fields now that
          // their containers are actually visible and measurable
          syncInlineElements();
        } else if (searchKeydown) {
          active = false;
        }

        // Upsell impression: once per popover open
        if (classes.indexOf("active") > -1) {
          maybeTrackUpsellShown();
        } else {
          upsellShownThisOpen = false;
        }
      });
    });

    observer.observe(targetNode, { attributes: true });
  },
]);
